import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from './services/common.service';
import { AuthService } from './auth-module/services/auth.service';
import { StoreService } from './services/store.service';
import { UserService } from './services/user.service';
import { NotificationService } from './services/notification.service';
import { ConfigExtensions } from './utils/config-extensions';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
    title = 'portal-cetatean';

    constructor(
        private commonService: CommonService,
        private router: Router,
        private authService: AuthService,
        private storeService: StoreService,
        private userService: UserService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        const storedTari = localStorage.getItem(environment.config.storageKey + 'tari');
        const storedJudete = localStorage.getItem(environment.config.storageKey + 'judete');

        this.commonService.getTariActive().subscribe({
            next: (results) => {
                localStorage.setItem(environment.config.storageKey + 'tari', JSON.stringify(results));
            },
            error: (error) => {
                console.error('Error loading tari:', error);
            }
        });

        this.commonService.getJudeteActive().subscribe({
            next: (results) => {
                localStorage.setItem(environment.config.storageKey + 'judete', JSON.stringify(results));
            },
            error: (error) => {
                console.error('Error loading judete:', error);
            }
        });

        // ROeID: handle token/error from redirect URL
        this.handleRoeidCallback();
    }

    /**
     * Handle ROeID authentication callback.
     * Detects token or error from URL hash params after ROeID redirect.
     * Works for any route format: /#/?token=, /#/auth/callback?token=, etc.
     */
    private handleRoeidCallback(): void {
        const hash = window.location.hash;
        if (!hash.includes('?')) {
            return;
        }

        const queryString = hash.split('?')[1];
        const params = new URLSearchParams(queryString);
        const token = params.get('token');
        const error = params.get('error');

        if (error) {
            const message = params.get('message') || 'Autentificarea ROeID a eșuat. Vă rugăm să reîncercați.';
            this.notificationService.warningSwal(
                environment.config.customNotifications.headers.error,
                message,
                environment.config.customNotifications.icons.error
            );
            // Clean URL and redirect to login
            this.router.navigateByUrl('/pages/login', { replaceUrl: true });
            return;
        }

        if (!token) {
            return;
        }

        // 1. Store JWT token in localStorage
        this.authService.setAuthToken(token);

        // 2. Fetch user details from backend (bearer interceptor adds token automatically)
        this.userService.findDetails().subscribe({
            next: (res: any) => {
                const response = typeof res.status_code !== 'undefined' ? res : res.error;
                if (response.status_code === 200 && response.data?.user) {
                    // 3. Store user data
                    this.storeService.setUser(response.data.user);

                    // 4. Set authenticated state
                    this.authService.setAuthenticatedNext(true);

                    // 5. Redirect to dashboard (same logic as normal login)
                    setTimeout(() => {
                        if (ConfigExtensions.isProductionWithLimitedFeatures()) {
                            this.router.navigateByUrl('/dashboard/solicitari', { replaceUrl: true });
                        } else {
                            this.router.navigateByUrl('/dashboard/home', { replaceUrl: true });
                        }
                    }, 200);
                } else {
                    this.authService.logout();
                    this.notificationService.warningSwal(
                        environment.config.customNotifications.headers.error,
                        'Nu am putut prelua datele contului. Vă rugăm să reîncercați.',
                        environment.config.customNotifications.icons.error
                    );
                    this.router.navigateByUrl('/pages/login', { replaceUrl: true });
                }
            },
            error: (err: any) => {
                this.authService.logout();
                this.notificationService.warningSwal(
                    environment.config.customNotifications.headers.error,
                    'Autentificarea a eșuat. Vă rugăm să reîncercați.',
                    environment.config.customNotifications.icons.error
                );
                this.router.navigateByUrl('/pages/login', { replaceUrl: true });
            }
        });
    }
}
